import { render, staticRenderFns } from "./ObtainedMajorMultiplePickerInput.vue?vue&type=template&id=6ea048aa&scoped=true&"
import script from "./ObtainedMajorMultiplePickerInput.vue?vue&type=script&lang=js&"
export * from "./ObtainedMajorMultiplePickerInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea048aa",
  null
  
)

export default component.exports